import React from 'react'
import { Dialog } from 'primereact/dialog';
import { classNames } from 'primereact/utils';

const ModalFull = ({ header, contenido, visible, onHide, className = false }) => {

    return (
        <div>
            
            <Dialog id="editModal" visible={visible} maximized={true} maximizable={true}  header={header} modal className={classNames("modal__contenedor ", {'modal__screen_small2': className, 'modal__screen' : !className})} baseZIndex={1500}
                onHide={onHide} closable closeOnEscape={false}>
                {contenido}
            </Dialog>
        </div>
    )
}

export default ModalFull
